import React from "react";

import { Route } from "react-router-dom";

import DistancingHome from "pages/DistancingHome";
import RtHome from "pages/RtHome";

import ContentLayout from "./ContentLayout";

const routes = [
  {
    path: "/distancing",
    topbar: (props) => <DistancingHome.TopBar {...props}/>,
    main: (props) => <DistancingHome.Main {...props} />,
  },
  {
    path: "/rt",
    topbar: (props) => <RtHome.TopBar {...props}/>,
    main: (props) => <RtHome.Main {...props} />,
  },
];

export default function renderContentRoutes() {
  return routes.map(({ path, topbar, main }) => {
    return (
      <Route key={path} path={path}>
        <ContentLayout topBar={topbar} content={main}/>
      </Route>
    );
  });
}
